module.exports = require('./wrapRelativeUrl')
